
import MobileDetect from 'mobile-detect'
import {detect} from 'detect-browser'
import utils from '@/_fdp/utils'
import FileSaver from 'file-saver'

// import * as moment from 'moment'
import 'moment'
import 'moment/locale/vi'
import 'moment/locale/en-gb'
import 'moment/locale/ko'
import moment from 'moment-timezone'
import vueMoment from 'vue-moment'

import { uniqueId } from 'lodash'
import popupTools from 'popup-tools'
import qs from 'qs'
import { Toast } from 'vant'
/*
 * init moment library
 */
moment.locale(localStorage.getItem('langauge')) // default(ko)
// moment().utcOffset(540) // timezone offet Asia/Seoul => GMT+9 => 9 * 60 = 540
moment.tz.setDefault('Asia/Seoul')

const MmpUtilsPlugin = {
  install: function (Vue) {
    Vue.use(vueMoment, {
      moment
    })

    let mmpUtils = {
      common: {
        getBrandColor () { // 브랜드 컬러 미적용
          // colorCode1 : BLUE, colorCode2 : INDIGO, colorCode3 : GREEN, colorCode4 : RED, colorCode5 : YELLOW
          let brandColor = ''
          // switch (window.vue.getStore('menu').getters.getBrandColor) {
          //   case 'BLUE':
          //     brandColor = 'colorCode1'
          //     break
          //   case 'INDIGO':
          //     brandColor = 'colorCode2'
          //     break
          //   case 'GREEN':
          //     brandColor = 'colorCode3'
          //     break
          //   case 'RED':
          //     brandColor = 'colorCode4'
          //     break
          //   case 'YELLOW':
          //     brandColor = 'colorCode5'
          //     break
          //   default:
          //     brandColor = 'colorCode2'
          //     break
          // }
          return brandColor
        },
        startLoading (vm) {
          Toast.loading({
            className: vm.$utils.common.getBrandColor(),
            mask: true,
            duration: 100000 // 1분 40초
            // duration: 3000
          })
        },
        /*
        name: endLoading
        용도: axios 종료시 Loading toast clear
       */
        endLoading (vm) {
          Toast.clear()
        },
        openWindowPopup (actionUrl, params, callback, options, post = true) {
          let popupId = uniqueId('mmp_w_popup_')
          if (typeof params !== 'object') {
            return
          }

          let defaultOptions = {
            width: 800,
            height: 600,
            menubar: 'no',
            resizable: 'yes',
            location: 'yes',
            scrollbars: 'no',
            centered: true,
            toolbar: 'no',
            status: 'no'
          }

          if (callback !== undefined) {
            var callBackEventFun = function (e, cancelFuc) {
              // receive data
              if (e.data !== undefined && e.data.type !== undefined && e.data.isMmpMessage) {
                callback(e.data)
                Vue.prototype.$removeMessage(cancelFuc, false)
              }
            }

            Vue.prototype.$receiveMessage(callBackEventFun, false)
          }

          if (post) {
            popupTools.popupWithPost(actionUrl, params, popupId, Object.assign({}, defaultOptions, options))
          } else {
            var callUrl = actionUrl + '?' + qs.stringify(params)
            popupTools.popup(callUrl, popupId, Object.assign({}, defaultOptions, options))
          }
        },
        maxLengthCheck (obj, maxlength) {
          var str = obj
          var strLength = str.length
          var tempObj = ''
          if ( strLength > maxlength ) {
            tempObj = str.substr(0, maxlength)
          } else {
            tempObj = str
          }
          return tempObj
        },
        getByteLength (s) {
          if (s == null || s.length === 0) {
            return 0
          }

          var size = 0
          for (var i = 0; i < s.length; i++) {
            size += this.charByteSize(s.charAt(i))
          }
          return size
        },
        cutByteLength (s, len) {
          if (s == null || s.length === 0) {
            return 0
          }

          var size = 0
          var rIndex = s.length

          for (var i = 0; i < s.length; i++) {
            size += this.charByteSize(s.charAt(i))
            if (size === len) {
              rIndex = i + 1
              break
            } else if (size > len) {
              rIndex = i
              break
            }
          }
          return s.substring(0, rIndex)
        },
        charByteSize (ch) {
          if (ch == null || ch.length === 0) {
            return 0
          }

          var charCode = ch.charCodeAt(0)

          if (charCode <= 0x00007F) {
            return 1
          } else if (charCode <= 0x0007FF) {
            return 2
          } else if (charCode <= 0x00FFFF) {
            return 3
          } else {
            return 4
          }
        },
        /****************************************************
         * 천단위 표시
         * @param {*} data
         */
        setNumberCommas (data) {
          var returnData = ''
          if ( typeof data !== 'undefined' && data !== '' && data !== null && data !== 'null' ) {
            data = data + ''
            returnData = data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          }
          return returnData
        },
        /****************************************************
         * 문자열 변경
         * @param {*} content 원본 데이터값
         * @param {*} word 변경대상 데이터값
         * @param {*} changeWord 변경할 데이터값
         */
        setReplaceAll (content, word, changeWord) {
          if ( typeof content !== 'undefined' && content !== '' && content !== null && content !== 'null' ) {
            var re = new RegExp(word, 'g')
            content = content + ''
            if ((content && content.indexOf(word) >= 0) || (typeof word === 'object')) {
              content = content.replace(re, changeWord)
            }
          }
          return content
        },
        /*
        name: replaceAll
        용도: 문자열에서 1) 특정 문자열을 2) 다른 문자열로 치환
        사용법: replaceAll('010-2222-3333', '-', '') -> 01022223333
        */
        replaceAll (str, searchStr, replaceStr) {
          return str.split(searchStr).join(replaceStr)
        },
        /****************************************************
         * Enter값 변경
         * @param {*} content 변경할 내용
         * @param {*} changeWord Enter값으로 변경대상 값
         */
        setEnterChange (content, changeWord) {
          var word = /(?:\r\n|\r|\n)/
          changeWord = (changeWord !== '' && typeof changeWord !== 'undefined') ? changeWord : '<br/>'
          if (content && changeWord) {
            return this.setReplaceAll(content, word, changeWord)
          }
          return content
        },
        /****************************************************
         * href tag 삭제
         * @param {*} content 변경할 내용
         */
        removeHrefTag (content) {
          var word = ''
          if (content) {
            return this.setReplaceAll(content, 'href', word)
          }
          return content
        },
        /****************************************************
         * 공백제거
         * @param {*} data
         */
        trim (data) {
          // return data.toString().replace(/(\s*)/g, "")
          if (!data) {
            return ''
          } else {
            return data.replace(/(^\s*)|(\s*$)/gi, '')
          }
        },
        /****************************************************
        *  null -> 공백 변환
        */
        nvl (data) {
          var retunData = this.isNull(data) ? data : ''
          return retunData
        },
        /****************************************************
         * Null 체크
         * @param {String or Object} data
         * @return null: true, not null: false
         */
        isNull (data) {
          var isReturn = true
          if (typeof data === 'string') {
            if (data !== '' && data !== null && data !== 'null' && typeof data !== 'undefined') isReturn = false
          } else {
            if (data !== null && data !== 'null' && typeof data !== 'undefined') isReturn = false
          }
          return isReturn
        },
        /****************************************************
         * Object Empty 체크
         * @param {Object} data
         * @return null: true, not null: false
         */
        isEmpty (data) {
          var isReturn = true
          if ( typeof data !== 'undefined' && data !== null && Object.keys(data).length !== 0 ) {
            isReturn = false
          }
          return isReturn
        },
        isNumberCheck (text) {
          var regNumber = /^[0-9]*$/
          return regNumber.test(text)
        },
        /****************************************************
         * 정규식 체크
         * @param {*} target 정규식 대상(none: regExp값을 사용시, number: 숫자만, email: 이메일, mobile:모바일, phone: 전화번호)
         * @param {*} data 정규식 체크 데이터
         * @param {*} regExp 직접 정규식 사용시
         */
        isRegExp (target, data, regExp) {
          var strRegExp = regExp
          if (target !== 'none') {
            strRegExp = this.getRegExp(target)
          }
          return strRegExp.test(data)
        },
        /****************************************************
         * 정규식 체크
         * @param {*} target 정규식 대상(none: regExp값을 사용시, number: 숫자만, email: 이메일, mobile:모바일, phone: 전화번호)
         */
        getRegExp (target) {
          var strRegExp = ''
          if (target === 'number') {
            // 숫자만 체크 정규식
            strRegExp = /^[0-9]+$/
          } else if (target === 'email') {
            // 이메일 체크 정규식
            // eslint-disable-next-line
            strRegExp = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
          } else if (target === 'password') {
            // 비밀번호 체크 정규식
            // 비밀번호 8~12자의 숫자, 영문자, 특수문자 모두 포함
            strRegExp = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,12}$/
          } else if (target === 'mobile') {
            // 핸드폰 체크 정규식
            strRegExp = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/
          } else if (target === 'phone') {
            // 전화번호 체크 정규식
            strRegExp = /^\d{2,3}\d{3,4}\d{4}$/
          } else if (target === 'date') {
            // 날짜 정규식 (YYYY-MM-DD)
            strRegExp = /^(19|20)\d{2}.(0[1-9]|1[012]).(0[1-9]|[12][0-9]|3[0-1])$/
          } else if (target === 'newPhone') {
            strRegExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})?[0-9]{3,4}?[0-9]{4}$/ // 전화번호 핸드폰번호 070 체크 하는 정규식
          }
          return strRegExp
        },
        /****************************************************
         * 날짜형 문자 포맷
         * @param {*} date
         * @param {*} fomat
         */
        getFomatDateString (date, fomat) {
          var returnData = ''
          if ( !this.isNull(date) ) {
            if ( date.length === 8 || date.length === 6 ) {
              var lastIdx = 4
              if ( date.length === 6 ) {
                lastIdx = 2
              }
              var year = date.substr(0, lastIdx)
              var month = date.substr(lastIdx, 2)
              var day = date.substr(lastIdx + 2, 2)
              returnData = year + fomat + month + fomat + day
            }
          }
          return returnData
        },
        /****************************************************
         * 자리수 0 채우기
         * @param {*} data 원본 데이터값
         * @param {*} digits 총 자릿수
         */
        getZeros (data, digits) {
          var zero = ''
          data = data.toString()
          if (data.length < digits) {
            for (var i = 0; i < digits - data.length; i++) { zero += '0' }
          }
          return zero + data
        },
        /****************************************************
         * 날짜 조회
         * @param {*} type
         */
        getDate (type) {
          switch (type) {
            case 'yyyy': return moment().format('YYYY')
            case 'yy': return moment().format('YY')
            case 'MM': return moment().format('MM')
            case 'dd': return moment().format('DD')
            case 'weeks': return moment.weekdays()
            case 'week': return moment().format('dddd')
            case 'HH': return moment().format('HH')
            case 'hh': return moment().format('hh')
            case 'mm': return moment().format('mm')
            case 'ss': return moment().format('ss')
            case 'a/p': return moment().format('a')
            case 'A/P': return moment().format('A')
            default: return moment().format() // "2019-05-02T18:52:50+09:00"
          }
        },
        /****************************************************
         * 현재년도 조회
         */
        getNowYear () {
          return this.getDate('yyyy')
        },
        /****************************************************
         * 현재일자 조회
         * @param {*} gubun - or / or .
         */
        getNowMonth () {
          return this.getDate('MM')
        },
        getNowDay (gubun) {
          if ( typeof gubun === 'undefined' || gubun === '' || gubun === null ) { gubun = '.' }
          return this.getDate('yyyy') + gubun + this.getDate('MM') + gubun + this.getDate('dd')
        },
        getConvertDate (val, type) {
          if ( type === 0 ) {
            return moment(val).format('YYYY.MM.DD')
          } else if ( type === 9 ) {
            return moment(val).format('HH:mm')
          } else {
            return moment(val).format('YYYY.MM.DD HH:mm')
          }
        },
        /****************************************************
         * 기준 날짜로 부터 day, month 가져오기
         * @param {Date} day
         * @param {Number} add
         * @param {String} type ('days', 'month')
         */
        getAddDate (day, add, type) {
          if ( day === null || day === undefined || day === '' ) {
            return moment().add(add, type).format('YYYY-MM-DD')
          } else {
            return moment(day).add(add, type).format('YYYY-MM-DD')
          }
        },
        /****************************************************
         * 시간(sec)로 시간 조회
         * @param {*} value 초(sec)
         * @returns 시간:분:초
         */
        timeInHours (value) {
          if ( typeof value !== 'undefined' && value !== null && value !== 0 ) {
            let hours = parseInt(Math.floor(value / 3600))
            let minutes = parseInt(Math.floor((value - (hours * 3600)) / 60))
            let seconds = Math.round((value - ((hours * 3600) + (minutes * 60))) % 60)

            let dHours = (hours > 9 ? hours : '0' + hours)
            let dMins = (minutes > 9 ? minutes : '0' + minutes)
            let dSecs = (seconds > 9 ? seconds : '0' + seconds)

            if (Number(dHours) > 0) {
              return dHours + ':' + dMins + ':' + dSecs
            } else {
              return dMins + ':' + dSecs
            }
          } else {
            return '00:00'
          }
        },
        base64ToBlob (base64, contentType, sliceSize) {
          contentType = contentType || ''
          sliceSize = sliceSize || 512

          var byteCharacters = atob(base64)
          var byteArrays = []

          for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize)

            var byteNumbers = new Array(slice.length)
            for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i)
            }

            var byteArray = new Uint8Array(byteNumbers)

            byteArrays.push(byteArray)
          }

          return new Blob(byteArrays, {type: contentType})
        },
        base64ToByteArray (base64) {
          let binaryString = window.atob(base64)
          let binaryLen = binaryString.length
          let bytes = new Uint8Array(binaryLen)
          for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i)
            bytes[i] = ascii
          }
          return bytes
        },
        saveFileByteArray (name, byte, type) {
          if (!type) type = 'application/octet'
          const url = window.URL.createObjectURL(new Blob([byte], {type: type}))
          const link = document.createElement('a')
          link.href = url
          link.download = name
          link.click()
        },
        saveFile (name, base64, type, ext, vm) {
          if (!type) type = 'application/octet'
          let iosType = ''
          if (ext === 'jpg') {
            iosType = 'application/jpg'
          } else if (ext === 'xls') {
            iosType = 'application/vnd.ms-excel'
          } else if (ext === 'xlsx') {
            iosType = 'application / vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          } else if (ext === 'pptx') {
            iosType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          } else if (ext === 'ppt') {
            iosType = 'application/vnd.ms-powerpoint'
          } else if (ext === 'doc') {
            iosType = 'application / msword'
          } else if (ext === 'docx') {
            iosType = 'application / vnd.openxmlformats-officedocument.wordprocessingml.document'
          } else if (ext === 'pdf') {
            iosType = 'application/pdf'
          } else if (ext === 'txt') {
            iosType = 'text/plain;charset=utf-8'
          }
          const binaryString = window.atob(base64)
          const binaryLen = binaryString.length
          const bytes = new Uint8Array(binaryLen)
          for (let i = 0; i < binaryLen; i++) {
            let ascii = binaryString.charCodeAt(i)
            bytes[i] = ascii
          }
          if (utils.getUserAgent().iOS) {
            if (iosType !== '') {
              FileSaver.saveAs(new Blob([bytes], {type: iosType}), name)
            } else {
              vm.$popup.open({
                cancelable: false,
                message: vm.$t('MSEM0284'),
                confirmInput: vm.$t('TSEM001025') // 확인
              })
            }
          } else {
            const url = window.URL.createObjectURL(new Blob([bytes], {type: type}))
            const link = document.createElement('a')
            link.href = url
            link.download = name
            document.body.appendChild(link)
            link.click()
          }
        },
        /****************************************************
         * 파일 다운로드
         * @param {*} file 객체
         * (fileNm or fileName or systemFileNm,
         *  fileSize,fileExtnsNm,
         *  attchId or attachId or attchFileId, fileId)
         */
        fileDownload (file, vm) {
          // console.log('fileDownload / file = ', file)
          let attachId = file.attchId
          if (attachId === undefined || attachId === '') {
            attachId = file.attachId
          }
          if (attachId === undefined || attachId === '') {
            attachId = file.attchFileId
          }
          let fileId = file.fileId
          let fileNm = file.fileNm
          if (fileNm === undefined || fileNm === '') {
            fileNm = file.fileName
          }
          if (fileNm === undefined || fileNm === '') {
            fileNm = file.systemFileNm
          }
          let fileExtnsNm = file.fileExtnsNm
          let fileSize = file.fileSize
          // console.log('fileDownload / attachId = ' + attachId)
          // console.log('fileDownload / fileId = ' + fileId)
          // console.log('fileDownload / fileNm = ' + fileNm)
          // console.log('fileDownload / fileExtnsNm = ' + fileExtnsNm)
          // console.log('fileDownload / fileSize = ' + fileSize)
          // console.log('fileDownload / MaxfileSize = ' + (1024 * 1024 * 20))
          if ( fileSize !== undefined && fileSize !== '' && fileSize >= 1024 * 1024 * 20 ) {
            vm.$popup.alert({
              cancelable: false,
              title: vm.$t('TSEM001024'), // 알림
              message: vm.$t('MSEM94001'),
              confirmInput: vm.$t('TSEM001025') // 확인
            })
            return false
          }
          let params = {
            attachId: attachId,
            fileId: fileId
          }
          this.startLoading(vm)

          const httpObj = window.vue.getInstance('http')
          const httpTarget = httpObj.busn || httpObj.b2c

          httpTarget.downloadFile(undefined, params)
            .then((response) => {
              const data = response.data.bizResponse
              if (data && data !== undefined) {
                if (data.status === 'OK') {
                  const result = data.data
                  this.saveFile(result.fileName, result.fileByteArray, result.fileContentType, fileExtnsNm, vm)
                }
              }
              console.log('fileDownload / success')
              this.endLoading(vm)
            }, (error) => {
              console.log('fileDownload / error = ', error)
              this.endLoading(vm)
              return Promise.reject(error)
            }).catch((error) => {
              console.log('fileDownload / error = ', error)
              this.endLoading(vm)
              vm.$popup.alert(vm.$el, {title: vm.$t('TSMO100096'), contents: vm.$t('TSEM920075')})
            })
        },
        /**
         * 파일명에서 확장자명 추출
         * @param filename   파일명
         * @returns _fileExt 확장자명
         */
        getExtensionOfFilename (filename) {
          const _fileLen = filename.length
          /**
           * lastIndexOf('.')
           * 뒤에서부터 '.'의 위치를 찾기위한 함수
           * 검색 문자의 위치를 반환한다.
           * 파일 이름에 '.'이 포함되는 경우가 있기 때문에 lastIndexOf() 사용
           */
          const _lastDot = filename.lastIndexOf('.')

          // 확장자 명만 추출한 후 소문자로 변경
          const _fileExt = filename.substring(_lastDot, _fileLen).toLowerCase()

          return _fileExt
        },
        /**
         * 미리보기 가능한 확장자인지 체크
         * @param fileExt   확장자명
         * @param extList   허용 확장자 리스트
         * @returns result true/false
         */
        checkExtension (fileExt, extList) {
          let result

          // 미리보기 가능한 확장자는 배열에 넣기
          let _arrExt = ['.xls', '.xlsx', '.ppt', '.pptx', '.doc', '.docx', '.pdf', '.txt', '.bmp', '.gif', '.tip', '.jpg', '.png', '.jpeg']
          if (extList && extList.length > 0) _arrExt = extList

          // 배열 요소를 검사하여 체크
          for (let i = 0; i < _arrExt.length; i++) {
            if (_arrExt[i] === fileExt) {
              result = true
              break
            } else {
              result = false
            }
          }

          return result
        },
        /**
         * Formates file size.
         *
         * @param {Number|String} size
         */
        formatFileSize (size, fixed) {
          const units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
          const threshold = 1024
          if (!fixed) fixed = 2
          size = Number(size)
          const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold))
          return `${(size / Math.pow(threshold, i)).toFixed(Number(fixed)) * 1} ${units[i]}`
        },
        /****************************************************
         * 바이트 변환
         * @param {*} byte 실제 파일 크기
         * @param {*} fixed 소수점 자릿수
         */
        getFileFormatBytes (fileSize, fixed) {
          let decimalNum = 1

          if ( typeof fixed === 'undefined' || fixed === null ) {
            fixed = 2
          }

          for (let i = 0; i < fixed; i++) {
            decimalNum = decimalNum * 10
          }

          // MB 단위 이상일때 MB 단위로 환산
          if (fileSize >= 1024 * 1024) {
            fileSize = fileSize / (1024 * 1024)
            fileSize = Math.floor(fileSize * decimalNum) / decimalNum
          } else if (fileSize >= 1024) { // KB 단위 이상일때 KB 단위로 환산
            fileSize = fileSize / 1024
            fileSize = Math.floor(fileSize * decimalNum) / decimalNum
          } else { // KB 단위보다 작을때 byte 단위로 환산
            fileSize = Math.floor(fileSize * decimalNum) / decimalNum
          }

          return this.setNumberCommas(fileSize)
        },
        /**
         * 바이트 단위 변환
         * @param {*} fileSize 실제 파일 크기
         */
        getFileFormatUnits (fileSize) {
          var returnUnit = ''

          // MB 단위 이상일때 MB 단위로 환산
          if (fileSize >= 1024 * 1024) {
            returnUnit = 'MB'
          } else if (fileSize >= 1024) { // KB 단위 이상일때 KB 단위로 환산
            returnUnit = 'KB'
          } else { // KB 단위보다 작을때 byte 단위로 환산
            returnUnit = 'byte'
          }
          return returnUnit
        },
        /****************************************************
         * Array Object 중복 제거
         * @param {*} array 배열
         * @param {*} key object key
         * @param {*} key2 object key (optional)
         */
        getUniqueObjectArray (array, key, key2) {
          return array.filter((item, i) => {
            return array.findIndex((item2, j) => {
              if (key2) {
                return item[key] === item2[key] && item[key2] === item2[key2]
              } else {
                return item[key] === item2[key]
              }
            }) === i
          })
        },
        /**
         * 맨앞 숫자 0 제거
         * @param {*} val
         */
        removeFrontZero (val) {
          return val.replace(/(^0+)/, '')
        },
        /*
          name: jindoChk
          용도: 일일진도량 체크 테스트 -> 1주일간 보지 않기 컨트롤
          작성자: 김동욱
          수정 : 2019-04-23
          수정 이유 : 일일진도량 체크로직 수정에 따른 미사용
        */
        // jindoChk (nextLrnCd) {
        //   let popOpen = false
        //   let date = new Date()
        //   let month = 0
        //   let day = 0
        //   let today = 0

        //   if (date.getMonth() + 1 < 10) {
        //     month = '0' + (date.getMonth() + 1)
        //   }

        //   if (date.getDate() < 10) {
        //     day = '0' + date.getDate()
        //   }
        //   today = date.getFullYear() + month + day
        //   if (nextLrnCd === '04') {
        //     popOpen = true
        //     if (localStorage.getItem('showYn')) { // 스토리지에 있을경우
        //       let show = (Number(today) - Number(localStorage.getItem('showYn'))) < 7
        //       if (show) { // 오늘날짜 - 저장한값 일주일 이상 차이나지 않는다
        //         popOpen = false
        //       }
        //     }
        //   }
        //   return popOpen
        // },
        /****************************************************
         * 특수기호가 포함된 내용 Html 소스로 변경
         * @param {*} val
         */
        getChangeSpecialHtml (val) {
          var tempDiv = document.createElement('div')
          tempDiv.innerHTML = val
          return tempDiv.innerText
        },
        /****************************************************
        목적: 받은 타입에 따라 날짜를 변경해서 반환
        사용법: 1) value에 20180311, 2) type에 'YYYY년M월'로 넣어주면 2018.3월로 변경됩니다.
         * @param {*} value 20180311
         * @param {*} type 'YYYY년M월'
        작성자: 김정윤
        */
        setDateFormat (value, type) {
          if (value !== null) {
            value = String(value)
            type = String(type)
            return moment(value).format(type)
          }
        },
        /****************************************************
        목적: text-field의 입력값 여부를 검사
        * @param {*} val 텍스트 입력값
        작성자: 김정윤
        */
        emptyCheck ( val ) {
          if (val === '' || val === null || val === undefined) {
            return false
          } else {
            return true
          }
        },
        /**
         * 파일명에서 확장자명 추출
         * @param filename   파일명
         * @returns _fileExt 확장자명
         */
        getExtOfFilename (filename) {
          let _fileLen = filename.length
          /**
           * lastIndexOf('.')
           * 뒤에서부터 '.'의 위치를 찾기위한 함수
           * 검색 문자의 위치를 반환한다.
           * 파일 이름에 '.'이 포함되는 경우가 있기 때문에 lastIndexOf() 사용
           */
          let _lastDot = filename.lastIndexOf('.')

          // 확장자 명만 추출한 후 소문자로 변경
          let _fileExt = filename.substring(_lastDot, _fileLen).toLowerCase()

          return _fileExt
        }
      },
      paging: {
        /****************************************************
         * 페이징 시작 Num
         * @param {*} pIdx 조회 페이지 Index
         * @param {*} pRowNum
         */
        getStartPageNum (pIdx, pRowNum) {
          if ( typeof pRowNum === 'undefined' || pRowNum === null ) {
            pRowNum = 10
          }
          return pIdx * pRowNum
        },
        /****************************************************
         * 페이징 종료 Num
         * @param {*} pIdx 조회 페이지 Index
         * @param {*} pRowNum
         */
        getEndPageNum (pIdx, pRowNum) {
          if ( typeof pRowNum === 'undefined' || pRowNum === null ) {
            pRowNum = 10
          }
          return ( (pIdx + 1) * pRowNum ) - 1
        }
      },
      userAgent: {
        detector: {},
        init () {
          this.detector = new MobileDetect(window.navigator.userAgent)
        },
        isDesktop () {
          // return this.detector.is('DesktopMode')
          return (!this.detector.phone() && !this.detector.tablet())
        },
        isTablet () {
          return (this.detector.tablet())
        },
        isPhone () {
          return (this.detector.phone() && !this.detector.tablet())
        },
        isApp () {
          return utils.getUserAgent().WEB_VIEW
          // return this.detector.match(new RegExp(window.vue.config.app.appAgentString))
        },
        isIE () {
          var browser = detect()

          return (browser && browser.name === 'ie')
        }
      },
      moment: {
        /*
         * [참고사항] https://momentjs.com/docs/
         * moment(time, format)
         * time: 현재시간 혹은 변경이 필요한 시간
         * format: 입력된 time(시간)의 format
         * ex) moment() : 현재 시간
         * ex) moment('10.04.2019 17:18', 'DD.MM.YYYY HH:mm') : 입력된 시간
         *
         * moment().format() : 입력된 시간을 지정된 format으로 변경
         * ex) moment().format('YYYY.MM.DD HH:mm') : 현재 시간을 년.월.일 시:분 형태로 반환
         * ex) moment('10.04.2019 17:18', 'DD.MM.YYYY HH:mm').format('YYYY.MM.DD HH:mm') : 입력된 시간을 년.월.일 시:분 형태로 반환
         */
        get (time, format) { // moment
          return moment(time, format)
        },
        now () { // now timestamp
          return moment().toDate().getTime()
        },
        getDate (time, format) { // javascript: new Date()
          return moment(time, format).toDate()
        },
        getTime (time, format) { // timestamp
          return moment(time, format).toDate().getTime()
        },
        getDefault () { // default information
          return {
            locale: {
              langCode: localStorage.getItem('language') || 'ko',
              dateformatCode: localStorage.getItem('dateFormat') || 'ko',
              timeZoneCode: localStorage.getItem('timeZone') || 'Asia/Seoul',
              currentDate: moment().toDate().getTime(), // 1555996328000
              currentDateString: moment().format() + '[Asia/Seoul]', // "2019-04-23T14:12:08+09:00[Asia/Seoul]"
              dateformat: window.vue.getStore('root').getters.getDateFormat
            }
          }
        },
        setLocale (locale) { // set locale
          return moment.locale(locale)
        },
        /*
         * setTimeZone 메소드 사용 제한
         * 서버의 데이터 타임존이 기본 Asia/Seoul 기준으로 내려옴
         * 추후 서버의 데이터가 타임존에 따라 내려오는 경우 주석을 풀고 사용
         */
        setTimeZone (timeZone) { // set timezone ('Asia/Seoul')
          // return moment.tz.setDefault(timeZone)
          return moment.tz.setDefault('Asia/Seoul')
        },
        formatter (time, format) {
          return moment(time).format(format)
        }
      },
      app: {
        config () {
          return window.vue.config.app
        }
      },
      cookie: {
        getCookie (cookieName) {
          var cookieValue = null
          if (document.cookie) {
            var array = document.cookie.split((escape(cookieName) + '='))
            if (array.length >= 2) {
              var arraySub = array[1].split(';')
              cookieValue = unescape(arraySub[0])
            }
          }
          return cookieValue
        },
        getCookieDomainName () {
          /*
          if (process.env.NODE_ENV === 'local') {
            domainNm = '.local.host'
          } else if (process.env.NODE_ENV === 'development') {
            domainNm = '.multi-dev.com'
          } else if (process.env.NODE_ENV === 'stage') {
            domainNm = '.multi-qa.com'
          } else {
            domainNm = '.multicampus.com'
          }
          */
          var a = document.createElement('a')
          a.href = location.href
          return a.hostname
        },
        deleteCookie (cookieName) {
          var temp = Vue.utils.cookie.getCookie(cookieName)
          if (temp) {
            console.log('deleteCookie>>>', cookieName, temp)
            Vue.utils.cookie.setCookie(cookieName, temp, (new Date(1)), '/', Vue.utils.cookie.getCookieDomainName())
          }
        },
        setCookie (cookieName, cookieValue, cookieExpire, cookiePath, cookieDomain, cookieSecure) {
          var cookieText = escape(cookieName) + '=' + escape(cookieValue)
          if (cookieExpire !== -1) cookieText += (cookieExpire ? '; EXPIRES=' + cookieExpire.toGMTString() : '')
          cookieText += (cookiePath ? '; PATH=' + cookiePath : '')
          cookieText += (cookieDomain ? '; DOMAIN=' + cookieDomain : '')
          cookieText += (cookieSecure ? '; SECURE' : '')
          document.cookie = cookieText
        }
      },
      user: {
        logout () {
          window.vue.getStore('root').commit('LOG_OUT')
          window.vue.getStore('token').commit('DELETE')
          window.vue.getStore('mmpAuth').commit('CLEAR_AUTO_LOGIN')
          window.vue.getStore('mmpAuth').commit('CLEAR_TOKEN_INFO')
          // 쿠키 삭제(자동로그인용)
          Vue.utils.cookie.deleteCookie('_nrw_lg')
          window.vue.getInstance('router').push({name: 'Login'})
        },
        setDeviceUserInfo (session, token) {
          // R/N user plugin
          let data = {
            userId: session.userId,
            mbrNo: session.mbrNo,
            mbrFnm: session.mbrFnm,
            information: window.vue.getStore('root').getters.getInformation,
            token,
            session,
            locale: localStorage.getItem('language')
          }

          window.fdpbridge.exec('getConfigPlugin', data,
            (success) => {
              console.log(success)
            },
            (error) => {
              console.log(error.message)
            })
        },
        async checkLoginSession () {
          let isNrwMobile = window.vue.getStore('mmpAuth').getters.isNrwMobile
          var tokenAuthObj = window.vue.getStore('mmpAuth').getters.getToken
          var tokenAuth = tokenAuthObj ? tokenAuthObj.tokenAuth : ''

          let rootStore = window.vue.getStore('root')
          let rootAuthenticated = rootStore.getters.getSession.authenticated
          let isAutoLogin = window.vue.getStore('mmpAuth').getters.isAutoLogin
          let authenticated = Vue.utils.cookie.getCookie('_nrw_lg') === 'true'

          // rootStore.getters
          if (isNrwMobile) {
            if (rootAuthenticated && !authenticated) {
              window.vue.getStore('root').commit('LOG_OUT')
            }
            if (!authenticated) {
              if (!isAutoLogin) {
                tokenAuth = ''
                window.vue.getStore('mmpAuth').commit('CLEAR_TOKEN_INFO') // 로컬스토리지 토큰삭제
              }
            }
          }

          console.log('>>>>>>> checkLoginSession::isNrwMobile', isNrwMobile, 'authenticated : ', authenticated, 'tokenAuth', tokenAuth, 'rootAu', rootStore.getters.getSession.authenticated)

          // console.log('>>>>>>> checkLoginSession:: isAutoLogin:', isAutoLogin, 'tokenAuthSess : ', tokenAuthSess, 'tokenAuthLocal.tokenAut', tokenAuthLocal.tokenAuth, 'autoToken :', autoToken)
          // if (rootStore.getters.getSession.authenticated || tokenAuth ) {
          if (authenticated || tokenAuth ) {
            let params = {
              ssoToken: tokenAuth,
              eduGrpCd: 'CUS0001',
              coGrpCd: 'B2C_18_001'
            }
            await this.goLoginCheck(params)
          }
        },
        async goLoginCheck (params) {
          // let isAutoLogin = window.vue.getStore('mmpAuth').getters.isAutoLogin
          let rootStore = window.vue.getStore('root')
          // console.log(this.$http)
          console.log(params)
          let promoInfo = window.vue.getStore('promoInfo').state.promoInfo
          promoInfo.eduGroupCode = params.eduGrpCd
          promoInfo.coGroupCode = params.coGrpCd

          window.vue.getStore('promoInfo').commit('SET_PROMO_INFO', promoInfo)

          let token = Object.assign({}, {
            tokenAuth: params.ssoToken
          })
          window.vue.getStore('token').commit('REGISTER', token)

          let httpObj = window.vue.getInstance('http')
          let httpTarget = httpObj.busn || httpObj.b2c

          let result = await httpTarget.viewMyInfo(undefined, { interceptIgnore: 'TRUE' })
          console.log('>>>>>>> checkLoginSession:: goLoginCheck>>>', result)
          const data = result.data
          if (data.status === 'OK') {
            let session = Object.assign({}, {
              loginTime: new Date().getTime(),
              timeout: window.vue.config.session.timeout,
              authenticated: true,
              userId: data.data.userInfo.loginId,
              mbrNo: data.data.userInfo.mbrNo,
              mbrFnm: data.data.userInfo.mbrFnm,
              mbrSxdsCd: data.data.userInfo.mbrSxdsCd
            })
            window.vue.getStore('root').commit('LOG_IN', session)

            // if (isAutoLogin) {
            //   var now = new Date()
            //   var time = now.getTime()
            //   var expireTime = time + 24 * 3600000 * 7 // 일주일
            //   now.setTime(expireTime)
            //   // 자동 로그인 키값은 쿠키로 설정(타임아웃 초기화)
            //   Vue.utils.cookie.setCookie('NRW_MTN', token.tokenAuth, now)
            // }
          } else {
            // console.log('ERROR : ' + data.message)
            window.vue.getStore('root').commit('LOG_OUT')
            window.vue.getStore('token').commit('DELETE')
            window.vue.getStore('mmpAuth').commit('CLEAR_AUTO_LOGIN')
            window.vue.getStore('mmpAuth').commit('CLEAR_TOKEN_INFO')
            // 쿠키 삭제(자동로그인용)
            Vue.utils.cookie.deleteCookie('_nrw_lg')
            if (rootStore.getters.getSession.authenticated) {
              console.log('>>> 로그아웃되었습니다. 메인페이지로 이동합니다')
              Vue.popup.alert(window.vue.$el, {title: '로그아웃', contents: '로그아웃되었습니다. 메인페이지로 이동합니다.'}).then((result) => {
                window.vue.getInstance('router').push({name: 'index'})
              })
            }
          }
        }
      },
      getClr2 () {
        let clr = this.common.getBrandRGBColor('clr2')
        return clr
      },
      getForceRedirectSiteUrl () {
        let linkUrl = ''
        if (process.env.NODE_ENV === 'local') {
          linkUrl = 'https://www.multicampus.com/'
        } else if (process.env.NODE_ENV === 'development') {
          linkUrl = 'http://www.multi-dev.com/'
        } else if (process.env.NODE_ENV === 'stage') {
          linkUrl = 'https://www.multi-qa.com/'
        } else {
          linkUrl = 'https://www.multicampus.com/'
        }
        return linkUrl
      },
      // 고유키 생성
      createUUID (prefix) {
        if (_.isEmpty(prefix)) { prefix = '' }

        var d = new Date().getTime()
        if (window.performance && _.isFunction(window.performance.now)) {
          d += performance.now()
        }

        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return prefix + uuid
      },
      // UUID에 해당하는 로컬스토리지 정보 삭제
      clearLocalStroage (uuid) {
        for ( var i = 0, len = localStorage.length; i < len; ++i ) {
          if ( localStorage.getItem(localStorage.key(i)).search(uuid) === -1) {
          }
        }
      },
      /**
       * ****************************************************
       * 주어진 hex 컬러코드 값이 밝은 계열인지 어두운 계열인지 확인
       * @param hex: 3자리 or 6자리 컬러코드
       */
      isLightColor (hex) {
        // const errMsg = 'isLightColor: 파라미터를 확인해 주세요'
        let colorCode, r, g, b, hsp

        if (hex === '' || hex === undefined || hex === null) {
          // console.warn(errMsg)
          return false
        } else {
          colorCode = hex.replace('#', '')

          if (colorCode.match(/^rgb/)) {
            colorCode = colorCode.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)
            r = colorCode[1]
            g = colorCode[2]
            b = colorCode[3]
          } else {
            colorCode = +('0x' + colorCode.slice(1).replace(colorCode.length < 5 && /./g, '$&$&'))
            r = colorCode >> 16
            g = colorCode >> 8 & 255
            b = colorCode & 255
          }

          hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
          )

          if (hsp > 127.5) {
            return true // 밝은 계열
          } else {
            return false // 어두운 계열
          }
        }
      }
    }
    Vue.utils = Vue.prototype.$utils = mmpUtils

    Vue.utils.userAgent.init()
  }
}

export default MmpUtilsPlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpUtils.js